import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

import { onTabletDown } from '@townsquare/responsive-grid';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const AddPeopleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  margin-left: ${token('space.200')};
  margin-right: ${token('space.200')};
  padding-bottom: ${token('space.300')};

  ${onTabletDown('display: none;')}

  & > img {
    margin-bottom: ${token('space.150')};
  }
`;
